import {adaptCameraStatusValue, getStatusValue} from '../../helpers';

export function columns() {
  return [{
    id: 1, title: 'UUID', field: 'uuid', filter: '', filterLabel: 'Filter By UUID', filterMinWidth: 105
  }, {
    id: 2, title: 'Camera Brand', field: 'cameraBrand', filter: '', filterLabel: 'Filter By Camera Brand', filterMinWidth: 165
  }, {
    id: 3, title: 'Camera Model', field: 'cameraModel', filter: '', filterLabel: 'Filter By Camera Model', filterMinWidth: 165
  }, {
    id: 4, title: 'IP address', field: 'IpAddr', filter: '', filterLabel: 'Filter By IP address', filterMinWidth: 165
  },
  {
    id: 5, title: 'Status', field: 'TestedStatus', filter: 'all', filterType: 'select', filterMinWidth: 65,
    getValue: rowData => getStatus(rowData),
    options: [{ label: 'All', value: 'all' }, { label: 'OK', value: 'OK' }, { label: 'NOK', value: 'NOK' }, { label: 'UNKNOWN', value: 'UNKNOWN' }]
  }];
}

function getStatus(rowData) {
  const statusName = adaptCameraStatusValue(rowData.TestedStatus);
  const colorStyle = {color: getColor(statusName)};
  return getStatusValue(statusName, colorStyle)
}

function getColor(status) {
  switch (status) {
  case 'OK' :
    return 'green';
  case 'NOK':
    return 'red';
  default:
    return 'gray';
  }
}
